import { SxProps } from "@mui/material";

const termsAndCondition: SxProps = {
  width: { md: "65%" },
  "& .label_terms": {
    fontSize: "20px",
    fontWeight: "700",
    color: "#23085A",
    marginTop: "20px",
  },

  "& .left_border": {
    borderLeft: "3px solid  #005CB9",
    display: "block",
    paddingLeft: "10px",
    margin: "10px 0",
    textDecoration: "none",
  },
  strong: {
    color: "#23085A",
  },
  a: {
    color: "#035C67",
  },
};

const conditionsBox: SxProps = {
  border: "1px dashed #009D8C",
  borderRight: "none",
  borderLeft: "none",
};
const modalBody: SxProps = {
  borderRadius: "8px",
  background: "#F0FCF8",
  padding: "16px",
  marginBottom: "28px",
};

const styles = { termsAndCondition, conditionsBox, modalBody };

export default styles;
